/*
 * @Author: huangzeshen
 * @Date: 2024-03-28 14:02:19
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-04-03 10:24:27
 * @FilePath: /waton-mobile/src/i18n/locals/zh-CN/info.js
 * @Description: 
 */


export default {
  'info.market.header.title': '资讯',
  'info.market.name.1': '美国股市',
  'info.market.name.2': '香港股市',
  'info.market.name.3': '中国股市',

  'nav.news.detai.title': '详情',
  'asset.stock.purchare.detail.add.optional': '添加自选成功',
  'asset.stock.purchare.detail.delete.optional': '移除自选成功',
  'news.days.ago': '天前',
  'news.hours.ago': '小时前',
  'news.minutes.ago': '分钟前',
  'news.seconds.ago': '秒前',
}
